module.exports = __webpack_public_path__ + "img/toilet-side.40c4e9bc.svg";